(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wunolo-faq"] && !Shopify.designMode) return;
  try {
    
  /* Fragen-Seite: Akkordeon, Live-Suche, Sprungnavigation.
     Ohne Abhaengigkeiten und ohne Nachladen: Die Fragen stehen schon im
     Markup, JavaScript schaltet nur Zustaende. Ohne JavaScript sind alle
     Antworten ueber die Tastatur erreichbar, nur nicht auf- und zuklappbar. */
  (function () {
    var wurzel = document.getElementById('wfq')
    if (!wurzel) return

    var karten = Array.prototype.slice.call(wurzel.querySelectorAll('.wfq-karte'))
    var kategorien = Array.prototype.slice.call(wurzel.querySelectorAll('.wfq-kat'))
    var suchfeld = document.getElementById('wfq-suchfeld')
    var treffer = document.getElementById('wfq-treffer')
    var leer = document.getElementById('wfq-leer')

    function oeffne (karte, offen) {
      karte.classList.toggle('offen', offen)
      var knopf = karte.querySelector('.wfq-frage')
      if (knopf) knopf.setAttribute('aria-expanded', String(offen))
    }

    /* Nur eine Antwort gleichzeitig offen. Bei aktiver Suche gilt das nicht:
       Dort sind die Treffer schon die Auswahl, und sie wieder zuklappen zu
       muessen waere eine Aufgabe ohne Zweck. */
    karten.forEach(function (karte) {
      var knopf = karte.querySelector('.wfq-frage')
      if (!knopf) return
      knopf.addEventListener('click', function () {
        var warOffen = karte.classList.contains('offen')
        if (!suchfeld || !suchfeld.value.trim()) {
          karten.forEach(function (k) { if (k !== karte) oeffne(k, false) })
        }
        oeffne(karte, !warOffen)
      })
    })

    /* Erste Frage offen, damit die Seite nicht als Liste geschlossener
       Kaesten beginnt und man das Muster sofort sieht. */
    if (karten.length) oeffne(karten[0], true)

    /* --------------------------------------------------------- Suche */
    if (suchfeld) {
      suchfeld.addEventListener('input', function () {
        var q = suchfeld.value.trim().toLowerCase()
        var gefunden = 0

        karten.forEach(function (karte) {
          var text = karte.getAttribute('data-suche') || ''
          var passt = !q || text.indexOf(q) !== -1
          karte.hidden = !passt
          if (passt) gefunden++
          /* Treffer aufgeklappt zeigen: Wer sucht, will die Antwort sehen,
             nicht erst noch klicken. Ohne Suche wieder zuklappen, sonst
             bliebe die Seite nach dem Leeren des Feldes komplett offen. */
          if (q) oeffne(karte, passt)
        })

        kategorien.forEach(function (kat) {
          var sichtbar = kat.querySelectorAll('.wfq-karte:not([hidden])').length
          kat.hidden = sichtbar === 0
        })

        if (treffer) {
          treffer.hidden = !q
          treffer.textContent = gefunden === 1
            ? '1 Antwort gefunden'
            : gefunden + ' Antworten gefunden'
        }
        if (leer) leer.hidden = !(q && gefunden === 0)

        if (!q) {
          karten.forEach(function (k, i) { oeffne(k, i === 0) })
        }
      })
    }

    /* ------------------------------------------- Sprungnavigation */

    /* Wer scrollt hier eigentlich? Im Horizon-Theme nicht das Fenster,
       sondern ein innerer Container (.page-wrapper). window.scrollTo lief
       deshalb ins Leere und die Themen-Leiste war tot (Befund 12.08., im
       Funnel am selben Tag derselbe Fall). Statt den Klassennamen des Themes
       fest zu verdrahten, wird der naechste wirklich scrollende Vorfahre
       gesucht: Das haelt auch, wenn das Theme umgebaut wird. */
    function scrollGeber () {
      var el = wurzel.parentElement
      while (el && el !== document.body) {
        var st = getComputedStyle(el)
        if (/(auto|scroll)/.test(st.overflowY) && el.scrollHeight > el.clientHeight + 4) return el
        el = el.parentElement
      }
      return null
    }

    /* Offset wegen der klebenden Kopfzeile: Ohne ihn verschwindet die
       Kategorie-Ueberschrift darunter. */
    var ABSTAND_OBEN = 110

    function springeZu (id) {
      var ziel = document.getElementById(id)
      if (!ziel) return
      var geber = scrollGeber()
      var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      var verhalten = sanft ? 'smooth' : 'auto'
      if (geber) {
        var oben = ziel.getBoundingClientRect().top - geber.getBoundingClientRect().top + geber.scrollTop - ABSTAND_OBEN
        geber.scrollTo({ top: oben, behavior: verhalten })
      } else {
        window.scrollTo({ top: ziel.getBoundingClientRect().top + window.scrollY - ABSTAND_OBEN, behavior: verhalten })
      }
    }

    wurzel.addEventListener('click', function (e) {
      var knopf = e.target.closest('[data-ziel]')
      if (!knopf) return
      springeZu(knopf.getAttribute('data-ziel'))
    })

    /* Die Themen-Leiste zeigt, wo man ist. Ohne das ist bei fuenf Kategorien
       nach zwei Bildschirmhoehen unklar, in welchem Abschnitt man liest. */
    if ('IntersectionObserver' in window && kategorien.length) {
      var knoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('.wfq-rail-knopf'))
      /* Nicht je Eintrag markieren, sondern nach jedem Durchlauf die OBERSTE
         sichtbare Kategorie bestimmen. Sonst gewinnt bei mehreren sichtbaren
         die zuletzt gemeldete, und auf einem hohen Bildschirm stand am
         Seitenanfang die zweite Kategorie markiert statt der ersten
         (Befund 12.08. bei 2400 px Fensterhoehe). */
      var sichtbar = {}
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (eintrag) {
          sichtbar[eintrag.target.id] = eintrag.isIntersecting
        })
        var oberste = null
        var besterAbstand = Infinity
        kategorien.forEach(function (kat) {
          if (!sichtbar[kat.id]) return
          var abstand = kat.getBoundingClientRect().top
          if (abstand < besterAbstand) { besterAbstand = abstand; oberste = kat.id }
        })
        knoepfe.forEach(function (k) {
          k.setAttribute('aria-current', String(oberste !== null && k.getAttribute('data-ziel') === oberste))
        })
      }, {
        /* Band von der Kopfzeile bis knapp unter die Bildschirmmitte. Mit
           -70% unten lag es so hoch, dass beim Seitenanfang keine Kategorie
           darin lag und die Leiste nichts markierte (12.08.). */
        rootMargin: '-' + ABSTAND_OBEN + 'px 0px -45% 0px'
      })
      kategorien.forEach(function (k) { beobachter.observe(k) })
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wunolo-so-funktionierts"] && !Shopify.designMode) return;
  try {
    
  /* Akkordeon im Fragen-Anriss. Ohne Abhaengigkeiten: Die Antworten stehen
     schon im Markup, JavaScript schaltet nur Zustaende. Ohne JavaScript ist
     die erste Antwort offen und der Rest per Tastatur erreichbar, nur nicht
     auf- und zuklappbar. */
  (function () {
    var wurzel = document.currentScript && document.currentScript.previousElementSibling
    if (!wurzel || !wurzel.classList || !wurzel.classList.contains('wsf')) {
      wurzel = document.querySelector('.wsf')
    }
    if (!wurzel) return

    var karten = [].slice.call(wurzel.querySelectorAll('.wsf-frage-karte'))
    if (!karten.length) return

    function oeffne (karte, offen) {
      karte.classList.toggle('offen', offen)
      var knopf = karte.querySelector('.wsf-frage')
      if (knopf) knopf.setAttribute('aria-expanded', String(offen))
    }

    karten.forEach(function (karte) {
      var knopf = karte.querySelector('.wsf-frage')
      if (!knopf) return
      knopf.addEventListener('click', function () {
        var warOffen = karte.classList.contains('offen')
        /* Nur eine Antwort gleichzeitig offen: Die Seite soll beim Lesen
           nicht unter den Fingern wachsen. */
        karten.forEach(function (k) { oeffne(k, false) })
        oeffne(karte, !warOffen)
      })
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
